import { get, put } from '../Services/http';
import { catchError } from './Error.action';
import {
  CART_LOAD_ERROR,
  CART_RECEIVE,
  CART_SHOW_MINI_CART,
  CART_ADD_TO_CART_ANIMATION,
} from '../constants';
import { loadSuggestedProducts } from './SuggestedProducts.action';

export const load = () => (dispatch, getState) => {
  return get('/api/cart')
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
    })
    .catch((ex) => {
      dispatch(catchError(ex, (error) => loadError(error)));
      return error;
    });
};

export const loadError = (error) => ({
  type: CART_LOAD_ERROR,
  payload: {
    error,
  },
});

export const receive = (cart) => (dispatch, getState) => {
  if (getState().cart.quantity != cart.quantity) {
    dispatch(triggerAddToCartAnimation());
  }

  return dispatch({
    type: CART_RECEIVE,
    payload: cart,
  });
};

export const toggle = () => (dispatch, getState) => {
  dispatch(show(!getState().cart.showMiniCart));
};

export const setShowMiniCart = (showMiniCart) => (dispatch) => {
  if (showMiniCart === true) {
    dispatch(loadSuggestedProducts(dispatch));
  }
  dispatch({
    type: CART_SHOW_MINI_CART,
    payload: {
      showMiniCart,
    },
  });
};

export const update = (
  articleNumber,
  quantity,
  abortController = null
) => (dispatch) => {
  return put(
    `/api/cart/update`,
    { articleNumber, quantity },
    abortController
  )
    .then((response) => response.json())
    .then((cart) => dispatch(receive(cart)))
    .catch((ex) => {
      dispatch(catchError(ex, (error) => loadError(error)));
      throw ex;
    });
};

let addToCartAnimationTimeoutId;
export const triggerAddToCartAnimation = () => (dispatch, getState) => {
  const addToCartAnimating = getState().cart.addToCartAnimating;
  if (!addToCartAnimating) {
    if (addToCartAnimationTimeoutId) {
      clearTimeout(addToCartAnimationTimeoutId);
    }

    dispatch(setAddToCartAnimating(true));
    addToCartAnimationTimeoutId = setTimeout(
      () => dispatch(setAddToCartAnimating(false)),
      500
    );
  }
};

const setAddToCartAnimating = (addToCartAnimating) => ({
  type: CART_ADD_TO_CART_ANIMATION,
  payload: {
    addToCartAnimating,
  },
});
